import React, { Fragment, useContext, useEffect, useState, memo } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import cx from "classnames";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

import { post } from 'axios';
import { compareAsc, format, addDays, addMonths } from 'date-fns';

// UI
import { Container, DateLayer, DateTimeLayer, openLayerFn, closeLayerFn, pickerStart, openAlertPopup } from "../Layout";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";

//env
import CanvasJSReact from "../../modules/env/canvasjs.react";

//graph
import BpGraphContent from "./BP/Graph/BpGraph";
import BsGraph from "./BS/Graph/BsGraph";


// Network
import { PostApi1104, PostApi1204, PostApi1403, PostApi1406, PostApi204 } from "../../modules/network/padoPost";
import { BmiGraph, SmmGraph } from "../common/Graph/Graph";
import { dupLogin } from "../common/AutoLogin/AutoLogin";

const interfaceDateFormat = 'yyyyMMdd';

export const FullScreenBp = (props) => {
  const { periodType, startDate, endDate, bpTimeCd, reload, setReload } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const [graphParam, setGraphParam] = useState();
  const [bpcTimeCd, setBpcTimeCd] = useState(bpTimeCd);

  const request1104 = (periodType, searchFromDt, searchToDt, bpcTimeCd) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFromDt;
        reqEndDate = searchToDt;
        break;
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1104(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        reqStartDate,
        reqEndDate,
        bpcTimeCd
      )
        .then((res) => {
          if (res.resultMsg === "SUCCESS") {
            setGraphParam(res.result);
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (reqStartDate.length == 8 && reqEndDate.length == 8) {
        if (
          reqStartDate != "" &&
          reqEndDate != "" &&
          reqStartDate > reqEndDate
        ) {
          openAlertPopup("선택한 날짜를 확인하세요.");
        }
      }
    }
  };

  const closeFullScreen = () => {
    if (phonecfg.phoneOS === "ANDROID") {
      window.java.appDisplayRotation(true);
    } else {
      window.location.href = "ep://appDisplayRotation/";
    }

    $(".list-full-layer").hide();
    setReload(true);
  };

  useEffect(() => {
    setTimeout(() => {
      request1104(periodType, startDate, endDate, bpcTimeCd);
      setTimeout(() => {
        setReload(false);
      }, 200);
    }, 200);
  }, [startDate, endDate, periodType, bpcTimeCd, reload]);

  return (
    <Fragment>
      <div
        className="blacklayer-container list-full-layer"
        id="fullScreen"
        style={{ maxWidth: "100%" }}
      >
        <div className="bl-blind" style={{ backgroundColor: "WHITE" }}></div>
        <div className="in-layerarea">
          <div className="in-diet-layerinfo">
            <a
              className="btn-closex"
              style={{
                backgroundColor: "#B2BEE5",
                zIndex: "10",
                opacity: ".5",
              }}
              onClick={() => closeFullScreen()}
            ></a>

            <div
              className="select-area tw"
              style={{
                width: "200px",
                height: "32px",
                left: "0",
                position: "absolute",
                top: "0",
              }}
            >
              <div
                style={{
                  width: "60%",
                  marginLeft: "2.5rem",
                  marginTop: "1rem",
                }}
              >
                <div className="select-custom-box in5">
                  <a
                    href={void 0}
                    className="btn-select"
                    style={{
                      height: "32px",
                      lineHeight: "32px",
                      fontSize: "12px",
                    }}
                  >
                    전체
                  </a>
                  <ul style={{ top: "33px" }}>
                    <li>
                      <a onClick={() => setBpcTimeCd("")}>전체</a>
                    </li>
                    <li>
                      <a onClick={() => setBpcTimeCd("AM")}>오전</a>
                    </li>
                    <li>
                      <a onClick={() => setBpcTimeCd("PM")}>오후</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {graphParam && (
              <div
                style={{
                  backgroundColor: "WHITE",
                  width: "100%",
                  position: "fixed",
                  bottom: "0",
                  height: "100%",
                }}
              >
                <BpGraphContent graphParam={graphParam} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const FullScreenBs = (props) => {
  const { periodType, startDate, endDate, type, reload, setReload } = props;
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);

  const [graphParam, setGraphParam] = useState();
  const [mealType, setMealType] = useState(type);

  const request1204 = (
    userinfo,
    cfg,
    periodType,
    searchFrDt,
    searchToDt,
    mealType
  ) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFrDt;
        reqEndDate = searchToDt;
        break;
    }

    if (periodType === 4) {
      if (reqStartDate != "" && reqEndDate != "") {
        if (reqStartDate > reqEndDate) {
          openAlertPopup("검색기간을 확인하세요");
          return;
        }
      }
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1204(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        reqStartDate,
        reqEndDate,
        mealType
      )
        .then((res) => {
          if (res.resultMsg === "SUCCESS") {
            setGraphParam(res.result);
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const settingMealType = (e, i) => {
    $(e.target).closest(".select-custom-box").removeClass("on");
    $(e.target)
      .closest(".select-custom-box")
      .find("a.btn-select")
      .html($(e.target).html());
    setMealType(i);
  };

  const closeFullScreen = () => {
    if (phonecfg.phoneOS === "ANDROID") {
      window.java.appDisplayRotation(true);
    } else {
      window.location.href = "ep://appDisplayRotation/";
    }
    setReload(true);
    $(".list-full-layer").hide();
  };

  useEffect(() => {
    // 팝업 닫기
    setTimeout(() => {
      request1204(userinfo, cfg, periodType, startDate, endDate, mealType);
      setTimeout(() => {
        setReload(false);
      }, 200);
    }, 200);
  }, [startDate, endDate, periodType, mealType, reload]);

  return (
    <Fragment>
      <div
        className="blacklayer-container list-full-layer"
        id="fullScreen"
        style={{ maxWidth: "100%" }}
      >
        <div className="bl-blind" style={{ backgroundColor: "WHITE" }}></div>
        <div className="in-layerarea">
          <div className="in-diet-layerinfo">
            <a
              className="btn-closex"
              style={{
                backgroundColor: "#B2BEE5",
                zIndex: "10",
                opacity: ".5",
              }}
              onClick={() => closeFullScreen()}
            ></a>

            <div
              className="select-area tw"
              style={{
                width: "200px",
                height: "32px",
                left: "0",
                position: "absolute",
                top: "0",
              }}
            >
              {/* <div style={{width:'20%', marginLeft:"10px", marginTop:"10px"}}> */}
              <div
                style={{
                  width: "60%",
                  marginLeft: "2.5rem",
                  marginTop: "1rem",
                }}
              >
                <div className="select-custom-box in5">
                  <a
                    href={void 0}
                    className="btn-select"
                    style={{
                      height: "32px",
                      lineHeight: "32px",
                      fontSize: "12px",
                    }}
                  >
                    전체
                  </a>
                  <ul style={{ top: "33px" }}>
                    <li>
                      <a onClick={(e) => settingMealType(e, "")}>전체</a>
                    </li>
                    <li>
                      <a onClick={(e) => settingMealType(e, "B")}>식사전</a>
                    </li>
                    <li>
                      <a onClick={(e) => settingMealType(e, "A")}>식사후</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {graphParam && (
              <div
                style={{
                  backgroundColor: "WHITE",
                  width: "100%",
                  position: "fixed",
                  bottom: "0",
                  height: "100%",
                }}
              >
                <BsGraph graphParam={graphParam} mealType={mealType} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const FullScreenBmi = memo((props) => {
    const {periodType, startDate, endDate, target} = props;
    const {userinfo, cfg, phonecfg} = useContext(AppContext);

    const [trgtWght, setTrgtWght] = useState();
    const [bmiArr, setBmiArr] = useState();
    const [wghtArr, setWghtArr] = useState();
    const [smmArr, setSmmArr] = useState();
    const [bdftArr, setBdftArr] = useState();
    const [vsrlftArr, setVsrlftArr] = useState();

    const [graph, setGraph] = useState([]);

    let bmiArrList = [];
    let wghtArrList = [];

    // 골격근량
    let smmArrList = [];
    // 체지방량
    let bdftArrList = [];
    // 내장지방
    let vsrlftArrList = [];

    const request1403 = (userinfo, trgtWght, vrtnType) => {
        PostApi1403(userinfo, cfg, phonecfg, periodType, startDate, endDate, 1, 100)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                for(let i=(res.result.length-1); i>=0; i--) {
                    bmiArrList.push(
                        {
                            "y": res.result[i].bmi
                            , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                        }
                    );
                    
                    wghtArrList.push(
                        {
                            "y": res.result[i].wght
                            , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                        }
                    );
                    
                    if(res.result[i].smm || res.result[i].smm != "") {
                        smmArrList.push(
                            {
                                "y":res.result[i].smm
                                , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                            }
                        )
                    }

                    if(res.result[i].bdft || res.result[i].bdft != "") {
                        bdftArrList.push(
                            {
                                "y":res.result[i].bdft
                                , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                            }
                        )
                    }
                    
                    if(res.result[i].vsrlft || res.result[i].vsrlft != "") {
                        vsrlftArrList.push(
                            {
                                "y":res.result[i].vsrlft
                                , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8)  + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                            }
                        )
                    }
                }

                setGraph({
                    ...graph,
                    "trgtWght":trgtWght,
                    "bmi":bmiArrList,
                    "wght":wghtArrList,
                    "smm":smmArrList,
                    "bdft":bdftArrList,
                    "vsrlft":vsrlftArrList
                });
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                // openLayerFn($('.alert-layer-logout'));
                dupLogin();
            } else {
                console.log("### ERR");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const request1406 = (userinfo) => {
        PostApi1406(userinfo, cfg, phonecfg)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                request1403(userinfo, res.result.trgtWght, res.result.vrtnType);
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                // openLayerFn($('.alert-layer-logout'));
                dupLogin();
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const [ reload, setReload ] = useState(false);

    useEffect(() => {
        // 팝업 닫기
        $(".btn-closex").click(function() {
            if(phonecfg.phoneOS === "ANDROID") {
                window.java.appDisplayRotation(true);
            } else {
                window.location.href = "ep://appDisplayRotation/";
            }
            
            $(".list-full-layer").hide();
        });
        
        if(periodType === 4) {
            if(startDate != 1 && endDate != 1){
                request1406(userinfo);
            }
        } else {
            request1406(userinfo);
        }
    }, [startDate, endDate, periodType]);

    return(
        <Fragment>
            <div className="blacklayer-container list-full-layer" id="fullScreenBmi" style={{maxWidth:"100%"}}>
                <div className="bl-blind" style={{backgroundColor:"WHITE"}}></div>
                <div className="in-layerarea">		
                    <div className="in-diet-layerinfo">			
                        <a className="btn-closex" style={{backgroundColor:"black", zIndex:"10", opacity: ".5"}}></a>
                    
                        {graph &&
                            <div style={{backgroundColor:"WHITE", width:"100%", position:"fixed", bottom:"0", height:"100%"}}>
                                {target === "Bmi" && <BmiGraph trgtWght={graph.trgtWght} bmiArr={graph.bmi} wghtArr={graph.wght} />}
                                {target === "골격근량" && <SmmGraph smmArr={graph.smm} subTitle={target} />}
                                {target === "체지방량" && <SmmGraph smmArr={graph.bdft} subTitle={target} />}
                                {target === "내장지방레벨" && <SmmGraph smmArr={graph.vsrlft} subTitle={target} />}
                            </div>
                        }
                        
                        
                    </div>
                </div>
            </div>
        </Fragment>
    );
})